import { gql } from '@grandvisionhq/graphql';
import { checkoutMutationResult } from '../fragments/checkout-mutation-result.js';
import { unknownUpdateCartFailure } from '../fragments/cart-mutation-failures.js';

const SET_CUSTOMER_DETAILS = gql`
  mutation SetCustomerDetails($customerDetailsInput: CheckoutSetCustomerDetailsInput!) {
    setCustomerDetails(customerDetailsInput: $customerDetailsInput) {
      ...CheckoutMutationResultFragment
      failures {
        ...UnknownUpdateCartFailureFragment
      }
    }
  }
  ${checkoutMutationResult}
  ${unknownUpdateCartFailure}
`;

export { SET_CUSTOMER_DETAILS };
//# sourceMappingURL=set-customer-details.js.map
